__turbopack_context__.v({
  "extra-options-title": "J7mDAq_extra-options-title",
  "list": "J7mDAq_list",
  "product": "J7mDAq_product",
  "product-footer": "J7mDAq_product-footer",
  "product-header": "J7mDAq_product-header",
  "product-list": "J7mDAq_product-list",
  "with-tooltip": "J7mDAq_with-tooltip",
});
